import { Box, Container, IconButton, Typography } from "@material-ui/core"
import { CategoryResponse } from "api"
import { useIsDesktop } from "common/MediaQueries"
import slugify from "common/utils/slugify"
import DiscountPromo from "components/DiscountPromo/DiscountPromo"
import { usePurchaseContext } from "components/PurchasePage/PurchaseContext"
import NextLink from "components/Reusable/Bit/NextLink"
import Image from "next/image"
import { useRouter } from "next/router"
import styled from "styled-components"
import BackIcon from "../../components/Icons/BackIcon"

const StyledBox = styled(Container)`
  margin-top: 80px;
  max-width: 1160px;
  padding: 0;

  ${(p) => p.theme.breakpoints.down("sm")} {
    margin-top: 94px;
    padding: 0px 16px;
  }
`

const StyledLink = styled.div`
  display: flex;
  cursor: pointer;
  margin-top: 40px;
  ${(p) => p.theme.breakpoints.down("sm")} {
    margin-top: 50px;
  }
  p {
    margin-right: 10px;
  }
  :hover {
    text-decoration: underline;
  }
`

const StyledTitle = styled(Typography).attrs({
  component: "h2",
  variant: "h2",
})`
  color: #000;
  white-space: nowrap;
  font-size: 40px;
  line-height: 0.6;
  font-family: Speedee, NarkisBlock, sans-serif;
  text-align: right;
  margin-top: 40px;
  ${(p) => p.theme.breakpoints.down("sm")} {
    margin-top: 30px;
  }
`

const StyledText = styled(Typography).attrs({ variant: "body2" })`
  color: #000;
  text-align: start;
  color: #000;
  line-height: 0.92;
  font-family: Speedee, NarkisBlock-Thin, sans-serif;
  height: auto;
  ${(p) => p.theme.breakpoints.down("sm")} {
    font-size: 20px;
    width: 150px;
  }

  :hover {
    text-decoration: underline;
  }
`

const StyledDataWrapper = styled(Box)<{ $promotion: boolean }>`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: 80px;
  ${(p) => (p.$promotion ? "margin-top: 0px" : "margin-top: 30px")};
  ${(p) => p.theme.breakpoints.down("sm")} {
    margin-bottom: 40px;
  }
  ${(p) => p.theme.breakpoints.down("xs")} {
    a {
      display: flex;
    }
  }
`
const StyledGiftCard = styled.div`
  margin-left: 10px;
  margin-top: 30px;
  cursor: pointer;
  span {
    border-radius: 5px;
  }
  img {
    transition: 0.2s all ease-in-out;
    &:hover {
      transform: scale(1.1);
    }
  }
  ${(p) => p.theme.breakpoints.up("md")} {
    width: 280px;
    margin-left: 20px;
  }
`

const StyledIconBtn = styled(IconButton)`
  padding: 1px;
  position: relative;
  bottom: 2px;
`

const StyledBoxWrapp = styled(Box)`
  display: flex;
  margin-top: 15px;
`

const CategoriesPage = ({ category }: { category: CategoryResponse }) => {
  const router = useRouter()
  const isDesktop = useIsDesktop()
  const { setPrevPath } = usePurchaseContext()

  return (
    <StyledBox>
      <StyledLink onClick={() => router.push("/")}>
        <StyledIconBtn>
          <BackIcon />
        </StyledIconBtn>
        <Typography variant="body1">חזרה לעמוד הבית</Typography>
      </StyledLink>
      <StyledTitle>{category?.name}</StyledTitle>
      <StyledBoxWrapp>
        {category?.categoryPromotion && (
          <DiscountPromo promoText={category?.categoryPromotion?.name} />
        )}
      </StyledBoxWrapp>
      <StyledDataWrapper
        $promotion={category?.categoryPromotion ? true : false}
      >
        {category?.blessing.map((data, index) => (
          <NextLink
            href={
              data.isAiImage
                ? `/create-ai`
                : data.slug
                ? `/giftcard/${slugify(data?.slug)}`
                : "/"
            }
            key={index}
            onClick={() => setPrevPath(router.asPath)}
          >
            <StyledGiftCard>
              <Image
                width={isDesktop ? "288px" : "150px"}
                height={isDesktop ? "203px" : "106px"}
                src={data?.image?.imageUrl}
                alt="img"
              />
              <StyledText>{data?.name}</StyledText>
            </StyledGiftCard>
          </NextLink>
        ))}
      </StyledDataWrapper>
    </StyledBox>
  )
}

export default CategoriesPage
